import { render, staticRenderFns } from "./MatchHeadstartReferral.vue?vue&type=template&id=dcea108c&"
import script from "./MatchHeadstartReferral.vue?vue&type=script&lang=ts&"
export * from "./MatchHeadstartReferral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports